import React from "react";
import { useTranslation } from "react-i18next";
import U2000ActionBtn from "../../../../u2000Core/components/buttons/U2000ActionBtn";
import U2000ResponsiveToolbar from "../../../../u2000Core/components/toolbar/U2000ResponsiveToolbar";
import { FaPlus, FaRegFile, FaTrashAlt } from "react-icons/fa";
import { useU2000AuthContext } from "../../../../u2000Core/context/auth/U2000UseAuthContext";
import type { U2000FormStateHandlers } from "../../../../u2000Core/reducer/formReducer/U2000FormStateHandlers";
import { U2000FormStateEnumState } from "../../../../u2000Core/reducer/formReducer/U2000FormState";
import { NS, U3120ROLES } from "../../../U3120";

interface U3120CustomerFormStateHandlers extends U2000FormStateHandlers<any> {
  getData: () => any;
  getFormState: () => U2000FormStateEnumState;
  addNewCustomer: () => void;
  modifyCustomer: () => void;
  deleteCustomer: () => void;
}

interface U3120CustomerFormBtnsComponentProps {
  formStateHandlers: U3120CustomerFormStateHandlers;
}

export const U3120CustomerFormToolBar: React.FC<U3120CustomerFormBtnsComponentProps> = ({ formStateHandlers }) => {
  const formState = formStateHandlers.getFormState();

  const { hasRole } = useU2000AuthContext();
  const { t } = useTranslation();

  const actions = [
    {
      key: "add",
      label: t("btnAdd", { ns: NS }),
      hasRole: hasRole(U3120ROLES.ADD),
      handleClick: () => {
        formStateHandlers.addNewCustomer();
      },
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaPlus,
      Component: U2000ActionBtn,
    },
    {
      key: "modify",
      label: t("btnModify", { ns: NS }),
      hasRole: hasRole(U3120ROLES.EDIT),
      handleClick: () => {
        formStateHandlers.modifyCustomer();
      },
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaRegFile,
      Component: U2000ActionBtn,
    },
    {
      key: "delete",
      label: t("btnDelete", { ns: NS }),
      hasRole: hasRole(U3120ROLES.DELETE),
      handleClick: () => {
        formStateHandlers.deleteCustomer();
      },
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaTrashAlt,
      Component: U2000ActionBtn,
    },
  ];

  return <U2000ResponsiveToolbar actions={actions} />;
};
